import React from "react";

function TakeYourGame() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Take Your Game to the Next Level</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  With Xeer Technology’s Crypto Gaming App Development services,
                  bring a new level of engagement and monetization to your
                  games. Join the future of gaming today—contact us to discuss
                  your project!
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default TakeYourGame;
